import { CreateDocx } from "./create";
import { Docx as DocxStructure } from "../structure";

/**
 * WordFragment
 */
class WordFragment extends CreateDocx {
    /**
     * Constructor
     */
    constructor() {
        // use a default DOCX structure to avoid preprocessing the default one
        const wordFragmentDocxStructure = new DocxStructure();
        super(wordFragmentDocxStructure);
        this.isWordFragment = true;
    }

    /**
     * To string implementation
     *
     * @returns XML
     */
    public toString(): string {
        return this.xml;
    }
}

export { WordFragment };
